import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import globalStyles from "../../../Styles/global.module.scss"
import styles from "../../../Styles/ComponentStyles/MainPages/Usergroup.module.scss"
import memberStyles from "../../../Styles/ComponentStyles/MainPages/Member.module.scss"

import Grid from '@mui/material/Grid2';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import GlobalTextfield from '../../../Utils/Layout/GlobalTextfield/GlobalTextfield';
import GlobalButton from '../../../Utils/Layout/GlobalButton/GlobalButton';
import GlobalSelect from '../../../Utils/Layout/GlobalSelect/GlobalSelect';
import { useSnackbar } from '../../../Utils/Layout/GlobalSnackbar/GlobalSnackbar';

import agent from '../../../Services/api';
import { MemberContext, MemberContextPayload } from '../../../Context/MemberDetailsContext';
import { GlobalUserContext, GlobalUserContextPayload } from '../../../Context/GlobalUserDetailContext';
import { GroupAppStatusRequestPayload } from '../../../models/memberAxiosModels';

const ViewUserGroup = () => {

    const {
        existingUserGroupDetails,
        setExitingUserGroupDetails
    } = useContext(MemberContext) as MemberContextPayload
    const { setFlagLoader } = useContext(GlobalUserContext) as GlobalUserContextPayload

    const navigate = useNavigate();
    const location = useLocation()
    const { showSnackbar } = useSnackbar();

    const [searchParams, setSearchParams] = useSearchParams();
    const fetchGroupId = searchParams?.get('groupId')
    const [appStatusOptions, setAppStatusOptions] = useState<any>(null)

    const fetchGroupDetails = async (fetchGroupId?: any) => {
        if (fetchGroupId) {
            const payload = {
                groupId: fetchGroupId
            }

            setFlagLoader(true)
            const response = await agent.getGroupAppswithStatusApi.get(payload)
            if (response?.status) {
                console.log("response of getGroupAppswithStatusApi", response);
                const responseData = response?.data
                setExitingUserGroupDetails(responseData)
                setFlagLoader(false)
            }
            else {
                const message = response?.error?.message || "Something Went Wrong!";
                showSnackbar(message, "error");
                setFlagLoader(false)
            }
        }
    }

    const fetchAppStatusOptions = async () => {
        setFlagLoader(true)
        const response = await agent?.getAppStatusOptionApi.get();
        if (response?.status) {
            console.log("response of getappstatusoption api", response);
            setAppStatusOptions(response?.data)
            setFlagLoader(false)
        }
        else {
            const message = response?.error?.message || "Something Went Wrong!";
            showSnackbar(message, "error");
            setFlagLoader(false)
        }
    }

    const fetchAppswithDefaultStatus = async () => {

        setFlagLoader(true);
        const response = await agent.getMacappwithDefaultStatusApi.get();
        console.log("log of getMacappwithDefaultStatusApi ", response);
        if (response?.status) {
            if (response?.data?.apps?.length > 0) {
                const formattedApps = response?.data?.apps?.map((app: any) => ({
                    appId: app.appId,
                    appName: app.appName,
                    appShortName: app.appShortName,
                    appImage: app.appImageString,
                    appFeaturedImage: app.appFeaturedImageString,
                    appDescription: app.appDescription,
                    appCreatedAt: app.appCreatedAt,
                    appUpdatedAt: app.appUpdatedAt,
                    appAddedToGroupAt: "",
                    appUpdatedInGroupAt: "",
                    appStatus: {
                        appStatusId: app.defaultAppStatus.defaultAppStatusId,
                        appStatusName: app.defaultAppStatus.defaultAppStatusName
                    }
                }));

                setExitingUserGroupDetails({
                    groupId: 0,
                    groupName: "",
                    isDefaultGroup: false,
                    apps: formattedApps
                });
            }
            setFlagLoader(false);
        }
        else {
            const message = response?.error?.message || "Something Went Wrong!";
            showSnackbar(message, "error");
            setFlagLoader(false)
        }
    };

    useEffect(() => {
        if (!fetchGroupId) {
            fetchAppswithDefaultStatus();
        }
    }, []);


    useEffect(() => {
        if (fetchGroupId) {
            fetchGroupDetails(fetchGroupId)
        }

        fetchAppStatusOptions()
    }, [fetchGroupId])


    const handleAddUserGroup = async () => {

        const payload: GroupAppStatusRequestPayload = {
            groupName: existingUserGroupDetails?.groupName,
            apps: existingUserGroupDetails?.apps?.map((ele: any) => ({
                appId: ele?.appId,
                appStatusId: ele?.appStatus?.appStatusId,
            }))
        }

        setFlagLoader(true)
        const response = await agent.addGroupAppandStatusApi.post(payload)
        if (response?.status) {
            const message = response?.message || "User Group added successfully!";
            showSnackbar(message, "success");
            // await fetchGroupDetails(fetchGroupId)
            navigate('/member/user-groups')
            setFlagLoader(false)
        }
        else {
            const message = response?.error?.message || "Something Went Wrong!";
            showSnackbar(message, "error");
            setFlagLoader(false)
        }
    }

    const handleEditGroup = async () => {

        const payload: GroupAppStatusRequestPayload = {
            groupName: existingUserGroupDetails?.groupName,
            apps: existingUserGroupDetails?.apps?.map((ele: any) => ({
                appId: ele?.appId,
                appStatusId: ele?.appStatus?.appStatusId,
            }))
        };
        const groupId = existingUserGroupDetails?.groupId;

        setFlagLoader(true);
        const response = await agent.editGroupAppandStatusApi.put(payload, groupId);
        console.log("log of editgroupappandstatus api", response);
        if (response?.status) {
            const message = response?.message || "User Group updated successfully!"
            showSnackbar(message, "success")
            // await fetchGroupDetails(fetchGroupId)
            navigate('/member/user-groups')
            setFlagLoader(false)
        }
        else {
            const message = response?.error?.message || "Something Went Wrong!";
            showSnackbar(message, "error");
            setFlagLoader(false)
        }
    }


    return (
        <>
            <Grid container>
                <Grid size={{ xs: 12 }}>
                    <Grid container>
                        <Grid size={{ xs: 12 }} sx={{ m: '10px 0px' }}>
                            <GlobalButton
                                value='Back'
                                size='small'
                                startIcon={<ArrowBackIcon sx={{ color: 'white' }} />}
                                className={styles.backBtn}
                                onClick={() => { navigate('/member/user-groups') }}
                            />
                        </Grid>

                        <Grid size={{ xs: 12 }} sx={{ m: '0px 0px 15px' }}>
                            <Grid container>
                                <Grid size={{ xs: 12 }} sx={{ mb: '8px' }}>
                                    <Typography component={'span'} className={`${globalStyles.globalTextV14} ${globalStyles.gblCWhite}`}>Group Name</Typography>
                                </Grid>
                                <Grid className={`${styles.vugDropdownItem}`}>
                                    <GlobalTextfield
                                        size='small'
                                        fullWidth
                                        stylingClassName={`${styles.userGroupTextfield}`}
                                        autoComplete='off'
                                        disabled={existingUserGroupDetails?.isDefaultGroup == true}
                                        value={existingUserGroupDetails?.isDefaultGroup ? "Default" : existingUserGroupDetails?.groupName}
                                        onChange={(e) => {
                                            setExitingUserGroupDetails({ ...existingUserGroupDetails, groupName: e.target.value })
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid className={`${styles.subscribeAppItem}`}>
                            <Grid container>
                                <Grid size={{ xs: 12 }}>
                                    <Typography component={'span'} className={`${globalStyles.globalTextV22} ${globalStyles.gblCWhite}`}>Subscribed Apps</Typography>
                                </Grid>
                                <Grid size={{ xs: 12 }} sx={{ margin: "15px 0px 0px" }}>
                                    <TableContainer className={styles.subscribeAppTableContainer}>
                                        <Table size='small' className={`${globalStyles.gblTableStyles}`}>
                                            <TableHead className={`${globalStyles.gblTableHeadStyles}`}>
                                                <TableRow>
                                                    <TableCell
                                                        className={`${globalStyles.gblTableHeadCell} ${styles.appNameCell}`}
                                                        sx={{ borderRadius: "5px 0px 0px 0px" }}>
                                                        <Typography
                                                            component={'span'}
                                                            className={`${globalStyles.globalTextV14}`}
                                                        >
                                                            APP NAME
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell
                                                        className={`${globalStyles.gblTableHeadCell} ${styles.appStatusCell}`}
                                                        sx={{ borderRadius: "0px 5px 0px 0px" }}
                                                    >
                                                        <Typography
                                                            component={'span'}
                                                            className={`${globalStyles.globalTextV14}`}
                                                        >
                                                            CURRENT APP STATUS &nbsp;
                                                            <Tooltip
                                                                placement="top"
                                                                arrow
                                                                title={
                                                                    <Grid container>
                                                                        {appStatusOptions?.macAppStatus?.length > 0 && appStatusOptions?.macAppStatus?.map((ele: any) => {
                                                                            return (
                                                                                <>
                                                                                    <Grid size={{ xs: 12 }}>
                                                                                        <Grid container sx={{ gap: "5px", margin: '3px 0px' }}>
                                                                                            <Grid>
                                                                                                <Typography component={'span'} className={`${globalStyles.gblCWhite}`} sx={{ fontSize: '14px', fontWeight: "600" }}>
                                                                                                    <span style={{ verticalAlign: 'text-bottom' }}>•</span>&nbsp;{ele?.appStatusName ? ele?.appStatusName : ""}:
                                                                                                </Typography>
                                                                                            </Grid>
                                                                                            <Grid sx={{ display: 'flex', alignItems: 'center' }}>
                                                                                                <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV13}`} sx={{ verticalAlign: 'middle' }}>
                                                                                                    {ele?.appStatusDescription ? ele?.appStatusDescription : ""}
                                                                                                </Typography>
                                                                                            </Grid>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </>
                                                                            )
                                                                        })}
                                                                    </Grid>
                                                                }
                                                                componentsProps={{
                                                                    tooltip: {
                                                                        sx: {
                                                                            backgroundColor: '#0087FF',
                                                                            color: '#fff',
                                                                            borderRadius: '8px',
                                                                            padding: '12px',
                                                                            fontSize: '13px',
                                                                            maxWidth: 300
                                                                        }
                                                                    },
                                                                    arrow: {
                                                                        sx: {
                                                                            color: '#0087FF'
                                                                        }
                                                                    }
                                                                }}
                                                            >
                                                                <InfoOutlinedIcon sx={{ fontSize: '18px', cursor: 'pointer', verticalAlign: 'sub' }} />
                                                            </Tooltip>
                                                        </Typography>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {existingUserGroupDetails?.apps?.map((ele) => {
                                                    return (
                                                        <>
                                                            <TableRow className={`${globalStyles.gblTableBodyRow}`}>
                                                                <TableCell className={`${globalStyles.gblTableCellText}`}>
                                                                    {ele?.appName}
                                                                </TableCell>
                                                                <TableCell
                                                                    className={`${globalStyles.gblTableCellText}`}
                                                                    align='left'
                                                                    sx={{ padding: '0px !important' }}
                                                                >
                                                                    <GlobalSelect
                                                                        className={`${styles.appStatusDropdown}`}
                                                                        size='small'
                                                                        fullWidth
                                                                        value={ele?.appStatus?.appStatusId || ""}
                                                                        options={
                                                                            appStatusOptions?.macAppStatus?.length ? appStatusOptions?.macAppStatus?.map((status: any) => ({ label: status.appStatusName, value: status.appStatusId })) : []
                                                                        }
                                                                        onChange={(e) => {
                                                                            const value = e?.target?.value

                                                                            const matchID = appStatusOptions?.macAppStatus?.find((status: any) => status?.appStatusId == value)
                                                                            if (!value) return

                                                                            const updateApps = existingUserGroupDetails?.apps?.map((app) => {
                                                                                if (app?.appId == ele.appId) {
                                                                                    return {
                                                                                        ...app,
                                                                                        appStatus: { appStatusId: matchID.appStatusId, appStatusName: matchID.appStatusName },
                                                                                    };
                                                                                }
                                                                                return app;
                                                                            })

                                                                            setExitingUserGroupDetails((prev: any) => ({
                                                                                ...prev,
                                                                                apps: updateApps
                                                                            }))
                                                                        }}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>
                                                        </>
                                                    )
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid size={{ xs: 12 }} sx={{ m: "10px 0px 0px" }}>
                            <Grid container className={`${styles.cancelSaveBtnContainer}`}>
                                <Grid className={`${styles.vugBtnsItem}`}>
                                    <GlobalButton
                                        fullWidth
                                        variant='outlined'
                                        size='medium'
                                        value='Cancel'
                                        className={`${styles.vugCancelBtn}`}
                                        onClick={() => {
                                            navigate('/member/user-groups')
                                        }}
                                    />
                                </Grid>
                                <Grid className={`${styles.vugBtnsItem}`}>
                                    <GlobalButton
                                        fullWidth
                                        variant='contained'
                                        size='medium'
                                        value={fetchGroupId ? 'Save' : 'Add Group'}
                                        disabled={!existingUserGroupDetails?.isDefaultGroup && (!existingUserGroupDetails?.groupName || existingUserGroupDetails?.groupName.trim() === "")}
                                        className={`${styles.vugSaveBtn}`}
                                        onClick={() => {
                                            if (fetchGroupId) {
                                                handleEditGroup()
                                            }
                                            else {
                                                handleAddUserGroup()
                                            }
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}


export default ViewUserGroup